import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FetchMerchantDeviceList } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const deviceListCountSlice = createAsyncThunk('get/deviceListCountSlice', FetchMerchantDeviceList);

export const DeviceListSlice = createSlice({
	name: 'deviceListCountSlice',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[deviceListCountSlice.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[deviceListCountSlice.rejected.toString()]: setAPIError,
		[deviceListCountSlice.fulfilled.toString()]: (
			state: ReturnType<typeof INITIAL_STATE>,
			action: IAPI_ACTION<any>,
		) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = action.payload;
		},
	},
});

interface IStates {
	[DeviceListSlice.name]: ReturnType<typeof DeviceListSlice.reducer>;
}

export const deviceListSelector = (state: IStates): any => {
	return state[DeviceListSlice.name] || {};
};

export const useDeviceList = (): any => useSelector(deviceListSelector);

export const getDeviceList =
	(params: { storeId?: number | string }) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(deviceListCountSlice({ ...params }));
		return;
	};

export const resetDeviceList =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(DeviceListSlice.actions.RESET());
		return;
	};
